import { Button, CheckThickIcon, TableInfoButton } from '@popsure/dirty-swan';
import { getEligibilityForShortTerm } from 'components/PrivateQuoteWidget/util';
import NextImage from 'next/image';
import { useState } from 'react';

import styles from './DiscountSection.module.scss';
import { ShortTermModal } from './ShortTermModal/ShortTermModal';
import travelIcon from './travel.svg';

export const DiscountSection = ({
  discountApplied,
  isFamily,
  onApplyDiscount,
  onRemoveDiscount,
  wantsToCoverFamily,
  setWantsToCoverFamily,
  hasEUPassport,
  hasPermanentResidencyPermit,
  isPlanningToStayMoreThan5Years,
  setHasEUPassport,
  setHasPermanentResidencyPermit,
  setIsPlanningToStayMoreThan5Years,
}: {
  discountApplied: boolean;
  isFamily?: boolean;
  onApplyDiscount: () => void;
  onRemoveDiscount: () => void;
  wantsToCoverFamily?: boolean;
  setWantsToCoverFamily: (value: boolean) => void;
  hasEUPassport?: boolean;
  hasPermanentResidencyPermit?: boolean;
  isPlanningToStayMoreThan5Years?: boolean;
  setHasEUPassport: (value: boolean) => void;
  setHasPermanentResidencyPermit: (value: boolean) => void;
  setIsPlanningToStayMoreThan5Years: (value: boolean) => void;
}) => {
  const [showShortTermModal, setShowShortTermModal] = useState(false);

  const hasAnsweredAllQuestions =
    hasEUPassport ||
    hasPermanentResidencyPermit ||
    isPlanningToStayMoreThan5Years !== undefined;

  const isFamilyEligibleForShortTerm = getEligibilityForShortTerm({
    hasEUPassport,
    hasPermanentResidencyPermit,
    isPlanningToStayMoreThan5Years,
  });

  const discountUnavailable =
    hasAnsweredAllQuestions && !isFamilyEligibleForShortTerm;

  return (
    <>
      {showShortTermModal && (
        <ShortTermModal
          isFamily={isFamily}
          wantsToCoverFamily={wantsToCoverFamily}
          setWantsToCoverFamily={setWantsToCoverFamily}
          isOpen={showShortTermModal}
          onClose={() => setShowShortTermModal(false)}
          onApplyDiscount={onApplyDiscount}
          hasEUPassport={hasEUPassport}
          isPlanningToStayMoreThan5Years={isPlanningToStayMoreThan5Years}
          hasPermanentResidencyPermit={hasPermanentResidencyPermit}
          setHasEUPassport={setHasEUPassport}
          setHasPermanentResidencyPermit={setHasPermanentResidencyPermit}
          setIsPlanningToStayMoreThan5Years={setIsPlanningToStayMoreThan5Years}
        />
      )}
      <div className="p-container">
        <div
          className={`d-flex f-wrap bg-white ai-center jc-between br8 px32 py16 mt8 gap8 ${styles.shadow}`}
        >
          <div className={`d-flex ai-center gap8 ${styles.leftCol}`}>
            <NextImage src={travelIcon} width={24} height={24} alt="plane" />
            <p className="p-p fw-bold">Living in Germany temporarily?</p>
          </div>

          <div className={`d-flex jc-center ${styles.rightCol}`}>
            {discountApplied && (
              <div className="d-flex ai-center gap8">
                <CheckThickIcon />
                <p className="p-p">Discount applied</p>
                <Button variant="textColor" onClick={onRemoveDiscount}>
                  Remove
                </Button>
              </div>
            )}

            {!discountApplied && !discountUnavailable && (
              <Button
                variant="textColor"
                onClick={() => setShowShortTermModal(true)}
              >
                Check for discount
              </Button>
            )}

            {discountUnavailable && (
              <div className="d-flex ai-center gap8">
                <p className="p-p">Discount not available</p>
                <TableInfoButton onClick={() => setShowShortTermModal(true)} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
